import { css } from "styled-components";

export default {
  UserDisplay: {
    style: css`
      padding: 15px;
    `,
  }
};
